import { useBatchValidateInvoice } from "@/api/invoice";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type ModalProps = {
  closeModal: () => void;
  isBatchValidationModalOpen: boolean;
};

export const InvoiceToBeValidatedBatchValidationModal = ({
  closeModal,
  isBatchValidationModalOpen,
}: ModalProps) => {
  const { t } = useTranslation(["boInvoices", "common"]);
  const { mutateAsync: batchValidateInvoice, isPending } = useBatchValidateInvoice();

  const handleBatchValidationAction = async () => {
    if (!isBatchValidationModalOpen) {
      return;
    }
    await batchValidateInvoice();
    closeModal();
  };

  return (
    <Modal
      open={isBatchValidationModalOpen}
      onClose={closeModal}
      dismissible
      size="sm"
      title={
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-full bg-green-100">
            <CheckCircle2 className="size-5 text-green-600" />
          </div>
          <span>{t("batchValidationModal.title")}</span>
        </div>
      }
      description={t("batchValidationModal.description")}
      footer={
        <div className="flex w-full flex-col gap-2 md:flex-row">
          <Button onClick={handleBatchValidationAction} disabled={isPending} className="flex-1">
            {isPending ? <Loader2 className="animate-spin" /> : t("batchValidationModal.submit")}
          </Button>
          <Button variant="outline" onClick={closeModal} disabled={isPending} className="flex-1">
            {t("common:actions.cancel")}
          </Button>
        </div>
      }
    />
  );
};
